import { render } from "./ConquerWorld.vue?vue&type=template&id=04511f0a&scoped=true"
const script = {}

import "./ConquerWorld.vue?vue&type=style&index=0&id=04511f0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04511f0a"]])

export default __exports__